import { CornerRadius, CornerRadiusValues } from '@picsart/design-system/foundation/cornerRadius';

const head = document.getElementsByTagName('head')[0];

const radiusStyleClassName = 'pa-radius-theme';

const radiuses = CornerRadius;

const updateRadiuses = () => {
  const style = document.createElement('style');
  style.classList.add(radiusStyleClassName);

  style.innerText = `
    :root {
      ${Object.entries(CornerRadiusValues).reduce((acc, [radius, value]) => `${acc}${radius}: ${value};\n`, '')}
    }
  `;

  head.appendChild(style);

  return () => {
    head.removeChild(style);
  };
};

export { radiuses, updateRadiuses };
